<template>
  <div>
    <div class="row no-print">
      <div class="col-md-3">
        <div class="row form-group mt-3">
          <div class="col-md-12 d-flex flex-between">
            <label class="mb-0 mr-3 text-primary">Tampilkan</label>
            <select class="form-control" v-model="perPage">
              <option value="10">10 data</option>
              <option v-if="rows && rows.length>10" value="25">25 data</option>
              <option v-if="rows && rows.length>25" value="50">50 data</option>
              <option v-if="rows && rows.length>50" value="100">100 data</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-6 offset-md-3">
        <div class="form-group mt-3">
          <input
            type="text"
            class="form-control with-icon-left without-label"
            v-model="filter"
            placeholder="Cari data di sini" ref="focusMe" 
          />
          <i class="material-symbols-outlined">search</i>
        </div>
      </div>
    </div>
    <datatable
      :columns="columns"
      :per-page="perPage"
      :data="rows"
      :filter="filter"
      class="table table-hover responsive"
    ></datatable>
                <br/>
            <p v-if="rows.length">Menampilkan {{rows.length>parseInt(perPage)?perPage:rows.length}} data dari total {{rows.length}} data</p>
<datatable-pager v-model="page" class="nav nav-tabs datatable-pager" type="abbreviated"></datatable-pager>
  </div>
</template>
<script>
export default {
  name: "TableResponsive",
  props: {
    filter: String,
    rows: Array,
    columns: Array,
    page: Number,
    perPage: Number
  },
  data: function() {
    return {};
  }
};
</script>
